import classNames from 'classnames';

import { WistiaVideo } from '@/components/WistiaVideo/WistiaVideo';
import { YoutubeVideo } from '@/components/YoutubeVideo/YoutubeVideo';
import type { VideoBlock } from '@/types';

import styles from './Video.module.scss';

interface Props {
    className?: string;
    video: VideoBlock['video'];
    autoPlay?: boolean;
}

export function Video({ className, video, autoPlay }: Props) {
    const { type, videoId } = video;

    return (
        <div className={classNames(styles.videoSection, className)}>
            <div className={styles.wrapper}>
                <div className={styles.embed}>
                    {type === 'wistia' ? (
                        <WistiaVideo id={videoId} autoPlay={autoPlay} />
                    ) : (
                        <YoutubeVideo id={videoId} autoPlay={autoPlay} />
                    )}
                </div>
            </div>
        </div>
    );
}
